import React, { useEffect, useState, useCallback } from "react";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "../constants";

export default function AdminCustomerComplaintList() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openItems, setOpenItems] = useState({}); // 🔄 Toggle tracking

  const hasAnyPending = (record) => {
    const statusList = [
      record.fields.complaintStatus,
      record.fields.complaintStatusAgain,
      record.fields.complaintStatusAgain3,
    ].filter(Boolean);

    return statusList.some((s) => s !== "Resolved");
  };

  // ✅ Wrap in useCallback to avoid re-creation on every render
  const fetchComplaints = useCallback(async () => {
    try {
      const res = await fetch(`${AIRTABLE_URL}?view=Grid%20view`, {
        headers: AIRTABLE_HEADERS,
      });

      const data = await res.json();

      if (!data.records) {
        console.error("❌ No records found");
        return;
      }

      const filtered = data.records.filter((rec) => hasAnyPending(rec));
      setRecords(filtered);
    } catch (err) {
      console.error("Error fetching:", err);
    } finally {
      setLoading(false);
    }
  }, []); // 👈 no deps since AIRTABLE_URL & HEADERS are constants

  useEffect(() => {
    fetchComplaints();
  }, [fetchComplaints]); // ✅ Safe dependency

  const toggleOpen = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  if (loading) return <p>Loading complaints...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>📋 Admin – Customer Complaints (All)</h2>

      {records.length === 0 ? (
        <p>No active complaints found.</p>
      ) : (
        records.map((rec) => {
          const isOpen = openItems[rec.id];
          return (
            <div
              key={rec.id}
              style={{
                border: "1px solid #ccc",
                padding: 15,
                marginBottom: 20,
                borderRadius: 8,
                background: "#f9f9f9",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p><b>Order ID:</b> {rec.fields.orderId || rec.fields.orderid}</p>
                <button
                  onClick={() => toggleOpen(rec.id)}
                  style={{
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    padding: "4px 8px",
                    cursor: "pointer",
                  }}
                >
                  {isOpen ? "Hide Details" : "Show Details"}
                </button>
              </div>

              {isOpen && (
                <>
                  <p><b>Phone:</b> {rec.fields.phone}</p>
                  <p><b>Name:</b> {rec.fields.name || "-"}</p>

                  {rec.fields.complaint && (
                    <>
                      <h4>First Complaint</h4>
                      <p><b>Category:</b> {rec.fields.complaintCategory}</p>
                      <p><b>Customer Complaint:</b> {rec.fields.complaint}</p>
                      <p><b>Technician Status:</b> {rec.fields.complaintStatus}</p>
                      <p><b>Technician Response:</b> {rec.fields.complaintResponse || "Not given"}</p>
                    </>
                  )}

                  {rec.fields.complaintAgain && (
                    <>
                      <h4>2nd Complaint</h4>
                      <p><b>Category:</b> {rec.fields.complaintCategoryAgain}</p>
                      <p><b>Customer Complaint:</b> {rec.fields.complaintAgain}</p>
                      <p><b>Technician Status:</b> {rec.fields.complaintStatusAgain}</p>
                      <p><b>Technician Response:</b> {rec.fields.complaintResponseAgain || "Not given"}</p>
                    </>
                  )}

                  {rec.fields.complaintAgain3 && (
                    <>
                      <h4>3rd Complaint</h4>
                      <p><b>Category:</b> {rec.fields.complaintCategoryAgain3}</p>
                      <p><b>Customer Complaint:</b> {rec.fields.complaintAgain3}</p>
                      <p><b>Technician Status:</b> {rec.fields.complaintStatusAgain3}</p>
                      <p><b>Technician Response:</b> {rec.fields.complaintResponseAgain3 || "Not given"}</p>
                    </>
                  )}

                  <p><b>Date:</b> {new Date(rec.createdTime).toLocaleString()}</p>
                </>
              )}
            </div>
          );
        })
      )}
    </div>
  );
}
